import { createFileRoute } from '@tanstack/react-router';

import { AddPanelPreferencePage } from '@/areas/settings/pcb/OrganizationSettings/PcbPage/AddPanelPreferencePage';
import { canEditPanelPreferences } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/pcb/panel-preferences/create')({
    staticData: {
        access: { permissions: canEditPanelPreferences },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AddPanelPreferencePage />;
}
